"use client";

import clsx from 'clsx';
import * as React from 'react';
import { useContext } from 'react';
import FormContext from './FormContext.js';
import { useBootstrapPrefix } from './ThemeProvider.js';
import { jsx as _jsx } from "react/jsx-runtime";
const FormCheckLabel = /*#__PURE__*/React.forwardRef(({
  bsPrefix,
  className,
  htmlFor,
  ...props
}, ref) => {
  const {
    controlId
  } = useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-label');
  return /*#__PURE__*/_jsx("label", {
    ...props,
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: clsx(className, bsPrefix)
  });
});
FormCheckLabel.displayName = 'FormCheckLabel';
export default FormCheckLabel;